import "./_audiobooks.scss"
import {useEffect, useState} from "react";
import Skeleton from "../../components/Skeleton/Skeleton";
import {motion} from 'framer-motion';
import { AudiobooksContainer2 } from "../../components/AudiobooksContainer/AudiobooksContainer2";
import { useFetch } from "../../utils/hooks/useFetch";


function AudiobooksPage() {
    const [activeTrackId, setActiveTrackId] = useState(null);
    const [data, loading] = useFetch("/JSON/audiobooks.json");

    const handleTrackEnd = (currentTrackId) => {
        const currentIndex = data.findIndex(
        (t) => t.title + t.id === currentTrackId
        );
        const nextTrack = data[currentIndex + 1];
        if (nextTrack) {
        setActiveTrackId(nextTrack.title + nextTrack.id);
        } else {
        setActiveTrackId(null);
        }
    };


    useEffect(() => {
        const ratio = 0.5
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: ratio
        }
        const handleIntersect = (entries, observer) => {
            entries.forEach(function(entry) {
                if (entry.intersectionRatio > ratio) {
                    entry.target.classList.add("reveal-visible")
                    observer.unobserve(entry.target)
                }
            })
        }
        const observer = new IntersectionObserver(handleIntersect, options);
        document.querySelectorAll('.reveal').forEach(function (r) {
            observer.observe(r);
        })
    }, )

    const array = Array.from({ length: 12 }, (_, i) => i);

    const currentDate = new Date();
    const isReleased = (releaseDate) => new Date(releaseDate) <= currentDate;

    return (
        <motion.div
            initial={{translateY : "100vh"}}
            animate={{translateY : 0, transition: {duration: 0.3} }}
            exit={{translateY: "-100vh", transition: {duration: 0.3} }}
        >
            <div className="audiobooks-title">
                <h2>Livres Audio</h2>
                <h3>Composition de virgules sonores</h3>
            </div>
            <div className="skeleton-audiobooks-container">
                {loading && array.map((n) =>
                    <Skeleton
                        key={n}
                    />)}
            </div>
            <div className={`body-audiobooks`}>
                {data.map((item, index) => (
                    <AudiobooksContainer2
                        key={item.id}
                        data={item}
                        activeTrackId={activeTrackId}
                        setActiveTrackId={setActiveTrackId}
                        onTrackEnd={handleTrackEnd}
                        isReleased={isReleased(item.release_date)}
                    />
                ))}
            </div>
        </motion.div>
    )
}

export default AudiobooksPage;